import { EnhancedAccount } from "library/accounts/types";
import { Product } from "library/hooks/types";
import { CreditCardTile } from "../CreditCardAccountSummary/CreditCardTile";
import { PersonalLoanCard } from "../PersonalLoanCard/PersonalLoanCard";

type Props = {
  account: EnhancedAccount;
  product?: Product;
  index: number; // TODO: We should get rid of this `index` and use some sort of id instead.
};

export const AccountCard = ({ account, product, index }: Props) => {
  // We don't use `account.type` here because,
  // unfortunately, it is available only for Credit Card accounts at the moment.
  switch (product?.type) {
    case "CREDIT_CARD": {
      return product ? (
        <CreditCardTile account={account} product={product} />
      ) : null;
    }

    case "PERSONAL_LOAN": {
      return (
        <div data-trackid={`pl-card-${index}`}>
          <PersonalLoanCard account={account} />
        </div>
      );
    }

    default: {
      return null;
    }
  }
};
